import { render, staticRenderFns } from "./AuditView.vue?vue&type=template&id=48c01868&scoped=true"
import script from "./AuditView.vue?vue&type=script&lang=js"
export * from "./AuditView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48c01868",
  null
  
)

export default component.exports